module.exports = __webpack_public_path__ + "d6671d41dde41d355619fe05b44f4aac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Italic/OpenSans-Italic.svg?v=1.1.0
// module id = 991
// module chunks = 0